module.exports = __webpack_public_path__ + "static/media/fav-icon.617eefc5.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/web-app/src/fav-icon.svg
// module id = 3879
// module chunks = 0